import React from 'react'
export default function RejectProductModal({ isOpen, onClose, product, onConfirmReject }) {
    const [reason, setReason] = React.useState('');
    const [isSending, setIsSending] = React.useState(false);
    const [error, setError] = React.useState(null);

    if (!isOpen || !product) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!reason.trim()) {
            setError('A reason for rejection is required.');
            return;
        }
        setIsSending(true);
        setError(null);

        try {
            // The onConfirmReject prop, passed from the dashboard, will handle
            // both the email sending and the database update.
            await onConfirmReject(product, reason);
            // The parent component will close the modal on success.
        } catch (err) {
            setError(err.message || 'An unexpected error occurred.');
            setIsSending(false); // Re-enable button on error
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl p-8 max-w-lg w-full">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-900">Reject Product</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <i className="fas fa-times text-xl"></i>
                    </button>
                </div>

                {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-sm mb-4">{error}</div>}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600">You are rejecting the product: <strong className="text-gray-900">{product.name}</strong></p>
                        <p className="text-sm text-gray-600">Listed by: <strong className="text-gray-900">{product.seller_name}</strong></p>
                    </div>
                    <div>
                        <label htmlFor="reason" className="block text-sm font-medium text-gray-700">Reason for Rejection*</label>
                        <textarea id="reason" name="reason" rows="5" required value={reason} onChange={(e) => setReason(e.target.value)} className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" placeholder="Provide a clear reason for rejecting this product..."></textarea>
                    </div>
                    <div className="flex justify-end space-x-4">
                        <button type="button" onClick={onClose} className="bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors">
                            Cancel
                        </button>
                        <button type="submit" disabled={isSending} className="bg-red-600 text-white py-2 px-6 rounded-lg hover:bg-red-700 transition-opacity disabled:opacity-50">
                            {isSending ? (<><i className="fas fa-spinner fa-spin mr-2"></i>Confirming...</>) : 'Confirm Rejection'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
